import React from 'react';
import Layout from '../../components/Layout';
import SeoLanding from './SeoLanding';
import NotFound from '../../components/NotFound/NotFound';
import getSeoLandingPageQuery from './getSeoLandingPage.graphql';
import { isSeoIndexState } from '../../core/seo/indexZone';

// Public service-in-city SEO landing page: /services/:service/:cityState
async function action({ params, query, client, store }) {
  const siteTitle =
    (store.getState().siteSettings &&
      store.getState().siteSettings.data &&
      store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  const path = `/services/${params.service}/${params.cityState}`;
  const preview = query && (query.preview === '1' || query.preview === 'true');

  let page = null;
  try {
    const { data } = await client.query({
      query: getSeoLandingPageQuery,
      variables: { path, preview: Boolean(preview) },
      fetchPolicy: 'network-only',
    });
    page = data && data.getSeoLandingPage;
  } catch (e) {
    page = null;
  }

  if (!page || page.status !== 200) {
    // SEO B1.3: a missing service/city page must return a REAL 404, not a soft-404 (HTTP 200 with
    // "Page Not Found" content) — soft-404s waste crawl budget and can de-rank the whole site.
    return {
      title: `Page Not Found | ${siteTitle}`,
      status: 404,
      component: (
        <Layout>
          <NotFound title={'Page Not Found'} />
        </Layout>
      ),
    };
  }

  return {
    title: page.title,
    description: page.metaDescription,
    keywords: page.metaKeywords,
    // Regional-focus SEO: pages outside the target zone are noindex,follow so authority concentrates
    // on PA/NJ/NY/DE instead of diluting across ~40k near-duplicate national pages (core/seo/indexZone).
    ...(isSeoIndexState(page.stateCode) ? {} : { robots: 'noindex, follow' }),
    component: (
      <Layout>
        <SeoLanding page={page} />
      </Layout>
    ),
  };
}

export default action;
